'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {useCreateProject} from "@/app/[locale]/common/utils/hooks/useCreateProject/useCreateProject";
import {Toast} from "@/app/[locale]/common/components/Toast/Toast";
import {FormAdmin} from "@/app/[locale]/common/components/FormAdmin/FormAdmin";
import {ProjectsClientComponent} from "@/app/[locale]/projects/ProjectsClientComponent/ProjectsClientComponent";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {PROJECTS_PAGE_BREAD_CRUMB_CONTENT, PROJECTS_PAGE_LABELS} from "@/app/[locale]/common/constants/projects";
import {ADMIN_MESSAGES} from "@/app/[locale]/common/constants/admin";
import {FIRST_PAGE} from "@/app/[locale]/common/constants/news";
import {TProjectsPageProps} from "@/app/[locale]/projects/types";
import {handleErrorMessage} from "@/app/[locale]/common/utils/functions/handleErrorMessage/handleErrorMessage";

export default function ProjectsPage({ searchParams }: TProjectsPageProps) {
    const currentPage = parseInt(searchParams.page || FIRST_PAGE, 10);
    const { projectStatus, createProject, error } = useCreateProject(currentPage);

    return (
        <div className={s.projects}>
            <Container>
                <Breadcrumbs crumb={[PROJECTS_PAGE_BREAD_CRUMB_CONTENT.PROJECTS]} />
                <Title title={PROJECTS_PAGE_LABELS.OUR_PROJECTS} />

                <FormAdmin type={'projects'} actionStatus={projectStatus} onSubmit={createProject} />
                <ProjectsClientComponent currentPage={currentPage} />

                <ContactUs/>

                {
                    projectStatus === 'success' &&
                    <Toast
                        title={ADMIN_MESSAGES.SUCCESS.title}
                        description={'Project was created.'}
                        Icon={ADMIN_MESSAGES.SUCCESS.Icon}
                        isOpen={true}
                    />
                }
                {
                    projectStatus === 'error' &&
                    <Toast
                        title={ADMIN_MESSAGES.ERROR.title}
                        description={handleErrorMessage(error) || ADMIN_MESSAGES.ERROR.description}
                        Icon={ADMIN_MESSAGES.ERROR.Icon}
                        isOpen={true}
                    />
                }
            </Container>
        </div>
    );
};